import { createWithEqualityFn as create } from 'zustand/traditional';

interface ITransitionContext {
    isPending: boolean;
    setIsPending: (isPending: boolean) => void;
}

const useGlobalTransition = create<ITransitionContext>(set => ({
    isPending: false,
    setIsPending: isPending => set({ isPending }),
}));

export { useGlobalTransition };
export type { ITransitionContext };
